import * as React from "react";
import {Component} from "react";
import WeatherCondition from "./WeatherCondition";
import Spacer from "../../../elements/Spacer";

interface IWeatherForecastProps {
    key: string;
    date: string;
    data: any;
    unitType: string;
    showSeparator: boolean;
}

class WeatherForecast extends Component<IWeatherForecastProps, {}> {
    public render() {
        const data = this.props.data;

        return <div key={this.props.key} style={this.props.showSeparator ? {borderBottom: '1px solid lightgrey'} : undefined}>
            <Spacer/>
            <p><b>{this.props.date}:</b></p>
            <WeatherCondition
                data={{
                    condition: data.condition,
                    temp_c: data.avgtemp_c,
                    temp_f: data.avgtemp_f
                }}
                unitType={this.props.unitType}
            />
            {
                this.props.unitType === 'celsius' ? <React.Fragment>
                    <div>
                        {"Min. Temperature: "}<b>{data.mintemp_c}</b><sup>&#176;{"C"}</sup>
                    </div>
                    <div>
                        {"Max. Temperature: "}<b>{data.maxtemp_c}</b><sup>&#176;{"C"}</sup>
                    </div>
                    <div>
                        {"Wind Max. Speed: "}<b>{data.maxwind_kph}</b>{" km/h"}
                    </div>
                </React.Fragment> : <React.Fragment>
                    <div>
                        {"Min. Temperature: "}<b>{data.mintemp_f}</b><sup>&#176;{"F"}</sup>
                    </div>
                    <div>
                        {"Max. Temperature: "}<b>{data.maxtemp_f}</b><sup>&#176;{"F"}</sup>
                    </div>
                    <div>
                        {"Wind Max. Speed: "}<b>{data.maxwind_mph}</b>{" mph"}
                    </div>
                </React.Fragment>
            }
            <Spacer/>
        </div>;
    }
}

export default WeatherForecast;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Weather/WeatherForecast.tsx